<template lang="pug">
section
  h2(style="text-align: center; margin-top: 40px") История
  el-row
    el-col(:span="24")
      datatable(ref="datatable", :url="'/payments'", :filters="filters", :row-class-name="tableRowClassName", default-order-by="id", default-sort-dir="descending")
        el-table-column(prop="document", label="Документ", width="120", class-name="document-column")
          template(slot-scope="scope")
            router-link(:to="'/payments/' + scope.row.id")
              el-tag(:type="tagType(scope.row)") {{ consts.paymentDocument[scope.row.document].title.replace(' известие', '') }}
            el-tooltip(v-if="scope.row.status != 2 && scope.row.overdue > 0", :content="'Просрочено с ' + scope.row.overdue + ' дни'", placement="top", effect="light")
              el-icon.icon-overdue(name="warning")
        el-table-column(prop="publishedAt", label="От дата", :formatter="dateFormatter", width="100")
        el-table-column(prop="num", label="Фактура №", :formatter="invoiceNumFormatter", width="100")
        el-table-column(v-if="showContragent", prop="Contragent", label="Контрагент", :formatter="contragentFormatter", width="140", :show-overflow-tooltip="true")
        el-table-column(type="expand")
          template(slot-scope="scope")
            p(v-for="s in scope.row.Subjects", :class="scope.row.type == 1 ? 'text-success' : 'text-danger' ")
              | {{ common.invoiceSubjectText(s, scope.row) }}
              span [{{ s.quantity }} x {{ common.formatPrice(s.price) }} {{ s.discount ? '(-' + s.discount + '%)' : ''}} = {{ common.formatPrice(s.quantity * s.priceDiscounted) }}]
        el-table-column(prop="Subjects", label="Основание", class-name="subjects-column", :formatter="subjectsFormatter")
        el-table-column(prop="priceTotal", label="Сума", :formatter="priceFormatter", width="80")
        el-table-column(prop="Company", label="Фирма", :formatter="companyFormatter", width="130")
        el-table-column(prop="method", label="Плащане", :formatter="methodFormatter", width="90")
</template>

<script>
import Datatable from './Datatable.vue'
import paymentsMixin from '../mixins/paymentsMixin.js'

export default {
  name: 'PaymentsHistory',
  mixins: [paymentsMixin],
  props: {
    filters: {default: {}},
    showContragent: {default: true}
  },
  data () {
    return {

    }
  },
  computed: {},
  methods: {

  },
  components: {
    datatable: Datatable
  }
}
</script>

<style lang="stylus">
</style>